module.exports = __webpack_public_path__ + "static/heart_emoji-6bcccdd0c436e45427763e713a8f3cc6.svg";